// vue3-migration -- Element
import langEn from 'element-plus/es/locale/lang/en';
import translations from './translations.json';

export default {
  ...translations,
  // vue3-migration -- Element
  ...langEn,
};
